var map = {
	"./boleto-barcode-dark.svg": 52963,
	"./boleto-barcode.svg": 13059,
	"./diners-dark.svg": 91282,
	"./diners.svg": 36990,
	"./elo-dark.svg": 89789,
	"./elo.svg": 26351,
	"./hipercard-v2-dark.svg": 89715,
	"./hipercard-v2.svg": 9438,
	"./mastercard-dark.svg": 30597,
	"./mastercard.svg": 10657,
	"./visa-dark.svg": 11506,
	"./visa.svg": 29433
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59403;